// extracted by mini-css-extract-plugin
export default {"option":"InputRadio_option__dfrhK","optionChecked":"InputRadio_optionChecked__0Fu+1","radioBtn":"InputRadio_radioBtn__3bBga"};